import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class HorizontalScrollService {

    private scrollPositionsMap: { [scrollKey: string]: number } = {};
    public forceUpdate: ReplaySubject<void> = new ReplaySubject<void>(1);

    constructor() { }

    /**
     * Fetch stored scroll position if the scroller has a key (indication position should be stored)
     */
    public fetchScrollPosition(scrollKey: string) {
        return this.scrollPositionsMap[scrollKey] || null;
    }

    /**
     * Store or update a scroller's position
     */
    public storeScrollPosition(scrollKey: string, position: number) {
        if(!scrollKey) return;
        this.scrollPositionsMap[scrollKey] = position;
    }

    /**
     * Force all listeners to update their scroll positions from the map
     */
    public forceScrollsUpdate() {
        this.forceUpdate.next();
    }

    /**
     * Watch forced scroll position update
     */
    public watchForceUpdate(): Observable<void> {
        return this.forceUpdate.asObservable();
    }
}
